// --
import React from 'react';
import TypDokumentApi from "./../api/gen/dokumenty/TypDokumentApi";
import AbstractReactComponent from "../AbstractReactComponent";
import ObjectSuggestField from "./ObjectSuggestField";

/**
 * Field pro výběr šablony.
 */
class SablonaField extends AbstractReactComponent {

    static PropTypes = {
        typDokumentKod: React.PropTypes.string.isRequired
    };

    props: {typDokumentKod: string};

    state : {typDokumentKod: string, list: ?SablonaVO[]} = {
        typDokumentKod: this.props.typDokumentKod,
        list: null
    };

    componentDidMount() {
        const {typDokumentKod} = this.props;
        this.requestData(typDokumentKod);
    }

    componentWillReceiveProps(nextProps) {
        const {typDokumentKod} = nextProps;
        if (typDokumentKod !== this.props.typDokumentKod) {
            this.requestData(typDokumentKod);
        }
    }

    requestData = (typDokumentKod : string) => {
        this.setState({typDokumentKod, list: null});
        TypDokumentApi.getSablonyProTypDokumentu(typDokumentKod).then(list => {
            if (typDokumentKod === this.state.typDokumentKod) {
                this.setState({list})
            }
        });
    };

    render() {
        const {list} = this.state;
        const {typDokumentKod, ...otherProps} = this.props;

        return <ObjectSuggestField
            dropdown={true}
            removable={false}
            items={list}
            itemValueAttrName="nazev"
            {...otherProps}
        />
    }
}

export default SablonaField;
